import { render } from "./AccountAlertContainer.vue?vue&type=template&id=ee755c2a&scoped=true"
import script from "./AccountAlertContainer.vue?vue&type=script&lang=js"
export * from "./AccountAlertContainer.vue?vue&type=script&lang=js"

import "./AccountAlertContainer.vue?vue&type=style&index=0&id=ee755c2a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee755c2a"]])

export default __exports__